import React from "react";
import { Modal } from "reactstrap";

import TeamForm from "./TeamForm";
import { Img } from "@/theme";

const AddTeamModal = ({ program, isOpen, toggle, onSaved }) => {
  const props = {
    btnLabel: "Add New Teammate",
    program,
    onSaved,
  };

  return (
    <Modal
      className="program-settings modal-2col modal-xl"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Team</span>
          <h3 className="modal-2col__title">Add New Teammate</h3>
          <p className="modal-2col__description">Fill in the details below to add a new member to your team.</p>
        </div>
        <Img src="img/pages/addTeammate.png" alt="teamate-image" className="modal-2col__illustration" />
      </div>

      <div className="right">
        <button
          type="button"
          className="modal-2col__close"
          onClick={toggle}
          aria-label="Close"
        >
          Close
        </button>
        <TeamForm {...props} />
      </div>
    </Modal>
  );
};

export default AddTeamModal;
